import { theme } from 'antd'
import { ConfigProviderProps } from 'antd/es/config-provider'
// 国际化失效：https://github.com/ant-design/ant-design/issues/56379
import zhCN from 'antd/es/locale/zh_CN'

const token = theme.getDesignToken()

export const themeConfig: ConfigProviderProps = {
  locale: zhCN,
  theme: {
    // https://ant-design.antgroup.com/docs/react/css-variables-cn#%E5%BC%80%E5%90%AF-zeroruntime-%E6%A8%A1%E5%BC%8F
    zeroRuntime: true,
    token: {
      fontSize: 14
    },
    components: {
      Menu: {
        subMenuItemBg: token.colorWhite,
        itemSelectedBg: token.colorWhite
        // itemSelectedColor: token.colorPrimaryActive
      }
    }
  },
  button: {
    autoInsertSpace: true
  }
}
